/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export class ClockTypes {
    static GUIDE_CLOCK: string = 'clock guide-clock';

    static SETTINGS_HEADER_CLOCK: string = 'clock settings-header-clock';

    static SETTINGS_HEADER_CLOCK_WITH_VIDEO_WINDOW: string =
        'clock settings-header-clock video-window-clock';

    static WATCH_VIDEO_CLOCK: string = 'clock watch-video-clock';
}
